import Spinner from 'react-bootstrap/Spinner';

interface SpinnerProps {
    className? : string,
    show? : boolean
    variant? : string
}

export const AccessibleSpinner = ({show, className, variant} : SpinnerProps) =>
{
    return show ? (
        <Spinner className={className} size="sm" animation="border" variant={variant}>
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    ) : null;
}
